// extracted by mini-css-extract-plugin
module.exports = {"aside":"Aside_aside__73TjM","aside__wrap":"Aside_aside__wrap__UGnVE","aside__list":"Aside_aside__list__v1Oo5","aside__cover":"Aside_aside__cover__biGtX"};